<ng-container *ngIf="!!result[0]">
    {{ result[0][1][itemLabel] || 'ukjent' }} 
</ng-container> 